import axios from "axios";
import { Config } from "../Config";
import {store} from "../stores";
import {logoutSaga} from "../stores/Login/Action";

const apiClient = axios.create({
  baseURL: Config.API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

apiClient.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log("error", error)
  if(error.response.status === 401){
    store.dispatch(logoutSaga());
  }
  return Promise.reject(error);
});


export default apiClient;


// WEBPACK FOOTER //
// ./src/Services/apiClient.js